import axios from 'axios';

import { APP_BASE_URL_ALARM, APP_BASE_URL_PCDO } from '../../Common/EndPoints';
import { getParsedLocalStorage } from '../../Utils/storage-utils';


//https://bitcommtechnologies.atlassian.net/browse/D24Q3-59?focusedCommentId=11368 -> USER LOGIN RESPONSE CHANGE REF


// Create a new Axios instance
const axiosInstancePcdo = axios.create({
    baseURL: APP_BASE_URL_PCDO,
});

// Add a request interceptor to set headers before each request
axiosInstancePcdo.interceptors.request.use(
    (config) => {
        const pcdo_user_data = getParsedLocalStorage("pcdo_user_data") ?? null;
        if (pcdo_user_data) {
            // config.headers['user_id'] = `${2}`;
            config.headers['user_id'] = `${pcdo_user_data.id}`;
        }
        return config;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
);

export default axiosInstancePcdo;
